// @flow

import React from "react";
import { Container, Label, Title } from "./styled-components";

type Props = {
  label: string,
  title: string
};

const Welcome = (props: Props) => (
  <Container data-qa-label="welcome-message">
    <Title>{props.title}</Title>
    <Label>{props.label}</Label>
  </Container>
);

Welcome.defaultProps = {
  label: "",
  title: ""
};

export default Welcome;
